/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ deleted: NonNullable<unknown>, purge: NonNullable<unknown> }} Artifacts_Trash_Item_DatesInputs */



/**
* | output |
* | --- |
* | "Deleted {deleted} · removed for good {purge}" |
*
* @param {Artifacts_Trash_Item_DatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_trash_item_dates = /** @type {((inputs: Artifacts_Trash_Item_DatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Trash_Item_DatesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gelöscht ${i?.deleted} · endgültig entfernt ${i?.purge}`)
	return /** @type {LocalizedString} */ (`Deleted ${i?.deleted} · removed for good ${i?.purge}`)
});